import React from 'react';
export const StickyCTA = () => {
  return <>
      {/* Mobile sticky CTA */}
      <div className="fixed bottom-0 left-0 w-full bg-white shadow-lg border-t border-gray-200 p-3 z-50 md:hidden" data-id="element-269">
        <div className="w-full" data-id="element-270">
          <a href="https://www.tryglisera.com/products/glisera-anti-cellulite-oil" target="_blank" rel="noopener noreferrer" className="block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-md text-base w-full text-center" data-id="element-271">
            Apply Discount & Check Availability
          </a>
        </div>
      </div>
      {/* Desktop sticky CTA - always visible when scrolling */}
      <div className="hidden md:block fixed bottom-0 left-0 w-full bg-white shadow-lg border-t border-gray-200 p-3 z-50" id="desktop-sticky-cta" data-id="element-272">
        <div className="w-full px-4" data-id="element-273">
          <a href="https://www.tryglisera.com/products/glisera-anti-cellulite-oil" target="_blank" rel="noopener noreferrer" className="block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-md text-base w-full text-center" data-id="element-274">
            Apply Discount & Check Availability
          </a>
        </div>
      </div>
    </>;
};